import Actions from "../Types";

const initialState = {
    isFetching: false,
    getDocsListSuccess: false,
    error: null,
    docs: [],
    status: [],
    isGetting: false,
    getStatusSuccess: false,
    isGettingDocs: false,
    getRequiredDocsSuccess: false,
    requiredDocs: {},

    isDownloading: false,
    downloadError: null,
    accessToken: null,
    isAccessToken: false,
    accessTokenError: null,
    centralPay: [],
    centralPayError: [],
    isCentralPayAccount: false,
    centralPayErrorCode: 0,

    centralPayPaymentResponseSuccess: [],
    isCentralPaymentConfirmed: false,
    centralPaymentResponseError: [],


    getBankNameAndCode: [],
    getBankNameAndCodeError: [],
    isBanksAvailable: false,

    verifyPWTSuccess: [],
    isVerificationStarted: false,
    isVerificationSuccess: false,
    verifyPWTError: [],
    certificationAmount: null,
    certificationAmountId: null,
    isCertificationAmount: false,
    gettingCertificationAmount: false,

    certificationAmountByAppId:null,
    isCertificationAmountByAppId: false,
    gettingCertificationAmountByAppId: false,

    applicationById: {},
    gettingAppById: false,
    errorGettingAppById: false
}

export default (state = initialState, action) => {
  
    switch (action.type) {
        case Actions.GET_DOCS_LIST_START:
            return {
                ...state,
                isFetching: true,
                error: null,
                getDocsListSuccess: false
            }
        case Actions.GET_DOCS_LIST_SUCCESS:
            return {
                ...state,
                isFetching: false,
                error: null,
                docs: action.payload,
                getDocsListSuccess: true
            }
        case Actions.GET_DOCS_LIST_FAILURE:
            return {
                ...state,
                isFetching: false,
                error: action.payload,
                getDocsListSuccess: false
            }
        case Actions.GET_REQUIRED_DOCS_LIST_START:
            return {
                ...state,
                isGettingDocs: true,
                error: null,
                getRequiredDocsSuccess: false
            }
        case Actions.GET_REQUIRED_DOCS_LIST_SUCCESS:
            return {
                ...state,
                isGettingDocs: false,
                error: null,
                requiredDocs: action.payload,
                // requiredDocs: localPayload,
                getRequiredDocsSuccess: true
            }
        case Actions.GET_REQUIRED_DOCS_LIST_FAILURE:
            return {
                ...state,
                isGettingDocs: false,
                error: action.payload,
                getRequiredDocsSuccess: false
            }
        case Actions.GET_USER_STATUS_START:
            return {
                ...state,
                isGetting: true,
                error: null,
                getStatusSuccess: false
            }
        case Actions.GET_USER_STATUS_SUCCESS:
            return {
                ...state,
                isGetting: false,
                error: null,
                status: action.payload,
                getStatusSuccess: true
            }
        case Actions.GET_USER_STATUS_FAILURE:
            return {
                ...state,
                isGetting: false,
                error: action.payload,
                getStatusSuccess: false
            }
        case Actions.CLEAR_DOCS_STATE:
            return {
                ...state,
                isFetching: false,
                getDocsListSuccess: false,
                error: null,
                docs: null,
                status: null,
                isGetting: false,
                getStatusSuccess: false
            }
            case Actions.DOWNLOAD_SDK_STARTS:
                return {
                    ...state,
                    isDownloading: true,
                    downloadError: null,
                };
            case Actions.DOWNLOAD_SDK_SUCCESS:
                return {
                    ...state,
                    isDownloading: false,
                };
            case Actions.DOWNLOAD_SDK_FAILURE:
                return {
                    ...state,
                    isDownloading: false,
                    downloadError: action.payload,
                };
                case Actions.GET_KONG_ACCESS_TOKEN_START:
                    return {
                        ...state,
                        isAccessToken: false,
                        accessToken: null,
                        accessTokenError: null
                    };
                case Actions.GET_KONG_ACCESS_TOKEN_SUCCESS:
                    return {
                        ...state,
                        isAccessToken: true,
                        accessToken: action.payload,
                        accessTokenError: null
                    };
                case Actions.GET_KONG_ACCESS_TOKEN_FAILURE:
                    return {
                        ...state,
                        isAccessToken: false,
                        accessToken: null,
                        accessTokenError: action.payload
                    };

                    case Actions.FETCH_CENTRALPAY_ACCOUNT_START:
                        return {
                            ...state,
                           centralPay: [],
                           isCentralPayAccount: false,
                           centralPayErrorCode: 0
                        };
                    case Actions.FETCH_CENTRALPAY_ACCOUNT_SUCCESS:
                        return {
                            ...state,
                            centralPay: action.payload,
                            isCentralPayAccount: true,
                            centralPayErrorCode: 200
                        };
                    case Actions.FETCH_CENTRALPAY_ACCOUNT_FAILURE:
                        return {
                            ...state,
                            centralPay: [],
                            centralPayError: action.payload,
                            isCentralPayAccount: false,
                            centralPayErrorCode: 500
                        };
                    case Actions.MAKE_PAYMENT_WITH_BANK_START:
                        return{
                            ...state,
                            centralPayPaymentResponseSuccess: [],
                            isCentralPaymentConfirmed: false,
                            centralPaymentResponseError: [],

                        }
                    case Actions.MAKE_PAYMENT_WITH_BANK_SUCCESS:
                        return {
                            ...state,
                            centralPayPaymentResponseSuccess: action.payload,
                            isCentralPaymentConfirmed: true,
                            centralPaymentResponseError: [],
                        }
                    case Actions.MAKE_PAYMENT_WITH_BANK_FAILURE:
                        return {
                            ...state,
                            centralPayPaymentResponseSuccess: [],
                            isCentralPaymentConfirmed: false,
                            centralPaymentResponseError: action.payload,
                        }

                    case Actions.GET_BANK_NAME_AND_CODE_START:
                        return {
                            ...state,
                            getBankNameAndCode: [],
                            getBankNameAndCodeError: [],
                            isBanksAvailable: false,

                        }
                    case Actions.GET_BANK_NAME_AND_CODE_SUCCESS:
                        return {
                            ...state,
                            getBankNameAndCode: action.payload,
                            getBankNameAndCodeError: [],
                            isBanksAvailable: true,

                        }
                    case Actions.GET_BANK_NAME_AND_CODE_FAILURE:
                        return {
                            ...state,
                            getBankNameAndCode: [],
                            getBankNameAndCodeError: action.payload,
                            isBanksAvailable: false,

                        }
                    case Actions.GET_VERIFY_BANK_TRANSFER_START:
                        return{
                            ...state,
                            verifyPWTSuccess: [],
                            isVerificationStarted: true,
                            isVerificationSuccess: false,
                            verifyPWTError: []
                        }
                    case Actions.GET_VERIFY_BANK_TRANSFER_SUCCESS:
                        return {
                            verifyPWTSuccess: action.payload,
                            isVerificationSuccess:true,
                            isVerificationStarted: false,
                            verifyPWTError: []
                        }
                    case Actions.GET_VERIFY_BANK_TRANSFER_FAILURE: 
                        return {
                            verifyPWTSuccess: [],
                            isVerificationSuccess:false,
                            isVerificationStarted: false,
                            verifyPWTError: action.payload

                        }
                    case Actions.GET_CERTIFICATION_AMOUNT_START:
                        return {
                            ...state,
                            isCertificationAmount: false,
                            gettingCertificationAmount: true,
                            certificationAmount: null,
                            certificationAmountId: null

                        }
                    case Actions.GET_CERTIFICATION_AMOUNT_SUCCESS:
                        return {
                            ...state,
                            isCertificationAmount: true,
                            gettingCertificationAmount: false,
                            certificationAmount: action.payload.amount,
                            certificationAmountId: action.payload.certification_amount_id,

                        }
                    case Actions.GET_CERTIFICATION_AMOUNT_FAILURE:
                        return {
                            ...state,
                            isCertificationAmount: false,
                            gettingCertificationAmount: false,
                            certificationAmount: null,
                            certificationAmountId: null
                        }

                    case Actions.GET_CERTIFICATION_AMOUNT_BY_APPID_START:
                        return {
                            ...state,
                            certificationAmountByAppId:null,
                            isCertificationAmountByAppId: false,
                            gettingCertificationAmountByAppId: true,
                            certificationAmountId: null,
                            merchantClass: null

                        }
                    case Actions.GET_CERTIFICATION_AMOUNT_BY_APPID_SUCCESS:
                        return {
                            ...state,
                            certificationAmountByAppId: action.payload.amount,
                            certificationAmountId: action.payload.certification_amount_id,
                            isCertificationAmountByAppId: true,
                            gettingCertificationAmountByAppId: false,
                            merchantClass: action.payload.merchant_class

                        }
                    case Actions.GET_CERTIFICATION_AMOUNT_BY_APPID_FAILURE:
                        return {
                            ...state,
                            certificationAmountByAppId: null,
                            certificationAmountId: null,
                            isCertificationAmountByAppId: false,
                            gettingCertificationAmountByAppId: false,
                            merchantClass: null

                        }
                    case Actions.GET_APPLICATION_BY_ID_START:
                        return {
                            ...state,
                            applicationById: {},
                            gettingAppById: true,
                            errorGettingAppById: false
                        }
                    
                        case Actions.GET_APPLICATION_BY_ID_SUCCESS:
                            return {
                                ...state,
                                applicationById: action.payload,
                                gettingAppById: false,
                                errorGettingAppById: false

                            }
                        case Actions.GET_APPLICATION_BY_ID_FAILURE:
                            return {
                                ...state,
                                applicationById: action.payload,
                                gettingAppById: false,
                                errorGettingAppById: true

                            }
        default:
            return state;
    }
}